import { useLocation } from "react-router-dom"
import { FaEdit } from "react-icons/fa";
import BasicDataTable from "../../../../../Component/BasicComponents/BasicDataTable";
import { useOutletDCRSummary } from "../../hooks/useCustomer";
import { useState } from "react";


const TableColumns = () => [
  {
    name: "Emp Name",
    selector: (row: { Employee: string }) => row.Employee||"-",
    width:'130px',
    wrap:true
  },
  {
    name: "Outlet Code",
    selector: (row: { OutletCode: string }) => row.OutletCode||"-",
    width:'150px'


  },
  {
    name: "Outlet Name",
    selector: (row: { OutletName: string }) => row.OutletName||"-",
    width:'150px'


  },
  {
    name: "Agenda Name",
    selector: (row: { AgendaName: string }) => row.AgendaName||"-",
    width:'130px'

  },
  {
    name: "Town Name",
    selector: (row: { Town: string }) => row.Town||"-",
    wrap: true,
    width:'150px'

  },
   {
    name: "DCR Date",
    selector: (row: { DcrDate: string }) => row.DcrDate||"-",
    wrap:true,
    width:'130px'

  },
   {
    name: "DCR Status",
    selector: (row: { DcrStatus: string }) => row.DcrStatus||"-",
    width:'130px'

  },
   {
    name: "Planned",
    selector: (row: { planned: string }) => row.planned||"-",
    width:'100px'

  },
   {
    name: "Manager",
    selector: (row: { manager: number }) => row.manager||"-",
    width:'150px',
    wrap:true
  },
];

const CustomerDcrSummaryTable=({OutletOrgId}:any)=>{
     const [pageState, setPageState] = useState({
     page: 1,
   });
   const [limitState, setLimitState] = useState({
     limit: 10,
   });
   const [search,setSearch]=useState({
     searchValue:null
   })


    const{data:DCRData}=useOutletDCRSummary({
        enabled:!!OutletOrgId,
        id:OutletOrgId,
        params:{
            page:pageState.page,
            limit:limitState.limit,
            search:search.searchValue
        }
    })


const formateTableData = () =>
  (DCRData?.data?.DCRSummaryData || []).map((key: any) => ({
    Employee: key.FirstName,
    OutletCode: key.OutletCode,
    OutletName: key.OutletName,
    AgendaName: key.AgendName,
    Town: key.TownName,
    DcrDate: key.DcrDate,
    DcrStatus: key.DcrStatus,
    planned: key.Planned,
    manager: key.Managers,
  }));




const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
 
      };
  });
      setLimitState((prevState: any) => {
        return {
          ...prevState,
          limit: limit,
        };
      });
    
  };
  const handlePagination = (pageNo: number) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  }

   const handleSearch = (searchValue: any) => {
    setSearch((prevState: any) => {
      return {
        ...prevState,
        searchValue,
      };
    });
  }


return(
    <div>
<BasicDataTable
paginationTotalRows={DCRData?.data?.Pagination.TotalDCRSummary}
columns={TableColumns()}
data={formateTableData()||[]}
Title="DCR"
onChangePage={(pageNo: number) => {
             handlePagination(pageNo);
           }}
          onChangeRowsPerPage={(newPerPage: any, page: any) => {
           handleonChangeRowsPerPage(newPerPage, page);
         }}
            handleSearch={(val: any) => {
          handleSearch(val);
        }}
/>
    </div>
)
}
export default CustomerDcrSummaryTable